import React from "react";
import { useNavigate } from "react-router-dom";

const SplatPage = ({ src, title }) => {
  const navigate = useNavigate();

  return (
    <div style={{ width: "100vw", height: "100vh", background: "#111", position: "relative" }}>
      <iframe
        src={src}
        style={{ width: "100%", height: "100%", border: "none" }}
        allow="fullscreen; xr-spatial-tracking"
        title={title}
      />
      <div style={{ position: "absolute", top: "20px", left: "20px", zIndex: 10 }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: "rgba(255,255,255,0.15)",
            border: "1px solid rgba(255,255,255,0.3)",
            color: "#fff",
            padding: "8px 16px",
            borderRadius: "8px",
            cursor: "pointer",
            backdropFilter: "blur(8px)",
            fontSize: "14px",
          }}
        >
          ← Back
        </button>
      </div>
    </div>
  );
};

export default SplatPage;
